import { z } from 'my-zod'

export const customDateErrorMap: z.ZodErrorMap = (error, ctx) => {
  if (error.code === z.ZodIssueCode.invalid_type) {
    return {
      message: 'Incorrect date format'
    }
  }
  return { message: ctx.defaultError }
}
